import { forwardRef, useState } from 'react';
import { Button, CircularProgress } from '@/shared/ui/mui';
import type { LoadingButtonProps } from './types';

export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  (
    {
      children,
      loading = false,
      disabled = false,
      variant = 'contained',
      size = 'medium',
      color = 'primary',
      fullWidth = false,
      startIcon,
      endIcon,
      onClick,
      type = 'button',
      sx,
    },
    ref,
  ) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
      if (onClick && !isLoading && !loading) {
        setIsLoading(true);
        try {
          await onClick();
        } finally {
          setIsLoading(false);
        }
      }
    };

    const showLoading = loading || isLoading;

    return (
      <Button
        ref={ref}
        variant={variant}
        size={size}
        color={color}
        fullWidth={fullWidth}
        disabled={disabled || showLoading}
        startIcon={!showLoading && startIcon}
        endIcon={!showLoading && endIcon}
        onClick={handleClick}
        type={type}
        sx={sx}
      >
        {showLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          children
        )}
      </Button>
    );
  },
);

LoadingButton.displayName = 'LoadingButton';
